// "What's new" — release notes feed authored by super-admin.
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Megaphone, Sparkles, Wrench, Bug, Shield } from "lucide-react";

const CAT_META = {
    feature:     { icon: Sparkles, color: "text-emerald-500", label: "FEATURE" },
    improvement: { icon: Wrench,   color: "text-sky-500",     label: "IMPROVED" },
    fix:         { icon: Bug,      color: "text-amber-500",   label: "FIX" },
    security:    { icon: Shield,   color: "text-rose-500",    label: "SECURITY" },
};

function fmtDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export default function WhatsNewWidget() {
    const [items, setItems] = useState(null);
    useEffect(() => {
        api.get("/home/widget/whats-new").then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, []);
    return (
        <div className="border border-border rounded-sm bg-card p-4 h-full" data-testid="home-widget-whats-new">
            <div className="flex items-center gap-1.5 mb-3">
                <Megaphone className="h-3.5 w-3.5 text-primary" strokeWidth={2} />
                <span className="eyebrow text-[10px]">What's new</span>
            </div>
            {items === null && <div className="text-xs text-muted-foreground">Loading…</div>}
            {items && items.length === 0 && (
                <div className="text-[12px] text-muted-foreground py-6 text-center">
                    No release notes yet.
                </div>
            )}
            {items && items.length > 0 && (
                <ul className="space-y-2.5 max-h-[300px] overflow-y-auto scrollbar-thin pr-1">
                    {items.map((it) => {
                        const meta = CAT_META[it.category] || CAT_META.feature;
                        const Icon = meta.icon;
                        return (
                            <li key={it.id} className="border-l-2 border-border pl-2.5"
                                data-testid={`home-whatsnew-${it.id}`}>
                                <div className="flex items-center gap-1.5 mb-0.5">
                                    <Icon className={`h-3 w-3 ${meta.color}`} strokeWidth={2} />
                                    <span className={`text-[10px] font-mono uppercase tracking-wider ${meta.color}`}>{meta.label}</span>
                                    {it.version && <span className="text-[10px] font-mono text-muted-foreground/70">v{it.version}</span>}
                                    <span className="text-[10px] font-mono text-muted-foreground/70 ml-auto">{fmtDate(it.created_at)}</span>
                                </div>
                                <div className="text-sm font-medium leading-tight">{it.title}</div>
                                {it.summary && (
                                    <div className="text-[12px] text-muted-foreground mt-0.5 leading-snug">
                                        {it.summary}
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
